var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"footer-feedback",on:{"click":_vm.feedback}},[_vm._v("\n  "+_vm._s(_vm.$t('components.footer-socials.feedback'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }